module.exports = __webpack_public_path__ + "img/exp.595da4b7.gif";